const formatTimeRange = (start: string, end: string, locale: string) => {
  const shouldUse24HourTimeFormat = ['es', 'fr', 'de', 'pt', 'it'].some(
    (prefix) => locale.slice(0, 2).toLowerCase() === prefix.slice(0, 2).toLowerCase(),
  );

  const startDate = new Date(start);
  const endDate = new Date(end);

  const startStr = startDate.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: !shouldUse24HourTimeFormat,
  });
  const endStr = endDate.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: !shouldUse24HourTimeFormat,
  });
  return `${startStr} - ${endStr}`;
};

const formatLocalizedTimeAndMonthRange = (start: string, end: string, locale: string) => {
  const shouldUse24HourTimeFormat = ['es', 'fr', 'de', 'pt', 'it'].some(
    (prefix) => locale.slice(0, 2).toLowerCase() === prefix.slice(0, 2).toLowerCase(),
  );

  const startDateNew = new Date(String(start));
  const endDateNew = new Date(String(end));
  const start1 = startDateNew.toLocaleString(locale, {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: !shouldUse24HourTimeFormat,
  });
  let end1 = '';
  if (
    startDateNew.getDay() === endDateNew.getDay() &&
    startDateNew.getMonth() === endDateNew.getMonth()
  ) {
    end1 = endDateNew.toLocaleString(locale, {
      timeStyle: 'short',
      hour12: !shouldUse24HourTimeFormat,
    });
  } else {
    end1 = endDateNew.toLocaleString(locale, {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: !shouldUse24HourTimeFormat,
    });
  }
  return `${start1} - ${end1}`;
};

export const DateUtils = {
  formatTimeRange,
  formatLocalizedTimeAndMonthRange,
};
